import { render, staticRenderFns } from "./valmistumispyynnot-virkailija-erikoistuva-laakari.vue?vue&type=template&id=4686803c&scoped=true&"
import script from "./valmistumispyynnot-virkailija-erikoistuva-laakari.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-virkailija-erikoistuva-laakari.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnot-virkailija-erikoistuva-laakari.vue?vue&type=style&index=0&id=4686803c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4686803c",
  null
  
)

export default component.exports